<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Stock info</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage" />
        </div>
      </div>
    </div>
    <loading-container :loading="loading">
      <div v-if="!list || list.length == 0" class="text-center">Not found!</div>
      <div v-else class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped dataTable no-footer">
                  <thead>
                    <tr>
                      <th>Catalog</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(catalog, index) in list" :key="index">
                      <td class="text-center" style="width: 300px">
                        <img
                          width="100"
                          class="border mr-2"
                          :src="catalog.catalogId | catalogInfo(mockupOptions, false)"
                          :title="catalog.catalogId"
                        />
                        <div class="design-position bg-primary text-white text-center border">
                          <small>{{ catalog.catalogId | catalogInfo(mockupOptions, true) }}</small>
                        </div>
                      </td>
                      <td>
                        <table class="table table-bordered">
                          <tr
                            v-for="item in sortSize(catalog.outOfStocks)"
                            :key="item.id"
                          >
                            <td class="p-2">
                              {{ item.color | mapColorName() }}
                            </td>
                            <td class="p-2">
                              {{ item.size | mapSizeName(sizesList) }}
                            </td>
                            <td class="p-2 font-bold text-danger">
                              Out of stock
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </loading-container>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

import LoadingContainer from "@/components/Misc/LoadingContainer";
import Breadcrumb from "@/components/Common/Breadcrumb";

export default {
  name: "StockInfo",
  components: {
    LoadingContainer,
    Breadcrumb,
  },
  beforeMount() {
    this.getList();
  },
  computed: {
    ...mapGetters({
      list: "outOfStock/list",
      loading: "outOfStock/loading",
      mockupOptions: "upload/mockupOptions",
      sizesList: "upload/sizesList",
    }),
    routeName() {
      return this.$router.name;
    },
    currentPage() {
      return this.$store.state.route.meta.title;
    },
  },
  methods: {
    ...mapActions({
      getList: "outOfStock/getList",
    }),
    sortSize(list) {
      return _.orderBy(list, 'color', 'asc');
    }
  },
  filters: {
    catalogInfo(catalogId, mockupOptions, isName) {
      const mockup = mockupOptions.find((o) => o.value == catalogId);
      if (isName) {
        return mockup ? mockup.text : "Unknown";
      } else {
        return mockup ? mockup.mockup_img : "";
      }
    },
    mapSizeName(size, sizesList) {
      const mockup = sizesList.find((o) => o.value == size);
      return mockup ? mockup.text : size;
    },
    mapColorName(color) {
      return color.split('_').map(x => _.capitalize(x)).join(' ');
    },
  },
};
</script>
